import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query'

import { useProjectService } from 'features/project/service'

// Caller-provided overrides for the underlying react-query options. Callers
// like useProjectDetails opt into `retry: false` so the UI can branch on the
// error state quickly instead of sitting on a spinner for 3 retry rounds.
// Keys defaulted below (queryKey, queryFn, refetchOnMount, staleTime, enabled)
// are not overridable.
type UseProjectOptions = Pick<UseQueryOptions, 'retry'>

export const useProject = (
  projectId: string,
  options: UseProjectOptions = {},
): UseQueryResult => {
  const projectService = useProjectService()

  return useQuery(
    ['project', projectId],
    () => projectService.getProject(projectId),
    {
      refetchOnMount: false,
      staleTime: 1000 * 60 * 5,
      enabled: !!projectId,
      ...options,
    },
  )
}
